import { Grid2 } from "@mui/material";

import { ApiService } from "../../../service/ApiService";

import { BlogArticleAction } from "../../../store/blogArticle/blogArticle.slice";

import { useGetBlogArticle, useScrollToTop } from "../../../hooks";

import { Container } from "../../../components";
import ToTopButton from "../../../components/common/ToTopButton";
import { MainContent } from "./components/MainContent/MainContent";
import SideBar from "./components/SideBar";

import { GridContainer } from "./BlogArticle.styled";

const BlogArticle = () => {
  useScrollToTop();
  useGetBlogArticle();

  return (
    <Container>
      <GridContainer container columnSpacing={2.5}>
        <Grid2 size={{ md: 8 }}>
          <MainContent />
        </Grid2>

        <Grid2 size={{ md: 4 }}>
          <SideBar />
        </Grid2>
      </GridContainer>
      <ToTopButton />
    </Container>
  );
};

BlogArticle.getServerSideState = async (store, params) => {
  const tag = params.location.split("/").filter(Boolean).slice(-1)[0];

  try {
    const { data } = await ApiService.getBlogArticle(tag);
    if (data) {
      store.dispatch(BlogArticleAction.saveServerBlogArticle(data));
    }
  } catch (e) {
    console.log("BlogArticle: Error in fetch blog article, ", e.message);
  }
};

export default BlogArticle;
